import { GuardModel } from "./guard-model";
import { IncidentModel } from "./incident-model";

export class IncidentGuardModel {
    public Id: number;
    public IncidentId: number;
    public Incident: IncidentModel;
    public GuardId: number;
    public Guard: GuardModel;
    public GuardName: string;
}



// WEBPACK FOOTER //
// ./src/app/models/incident-guard-model.ts